"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isNativeBorder;

// material underscore border is separated component instead of native input border
function isNativeBorder(style) {
  return style !== 'none none solid' && style !== 'none none dotted';
}